"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgOpenCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    fill: "inherit",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M11.263 5.697l3.417 3.201 4.875-.859a.353.353 0 01.033-.004l.033-.002c.18 0 .341.131.374.316l1.124 6.377a.38.38 0 01-.308.441L5.803 17.814a.381.381 0 01-.44-.31l-1.125-6.377a.38.38 0 01.308-.441l4.599-.812 2.118-4.177zm-2.707 6.128c-.11 0-.222.01-.337.03-.945.167-1.475.91-1.277 2.034.198 1.124.956 1.673 1.901 1.506.946-.166 1.47-.94 1.271-2.065-.173-.982-.774-1.505-1.558-1.505zm3.102-.475c-.14 0-.285.014-.432.04l-1.25.22.601 3.415.904-.16-.19-1.082.367-.064c.714-.126 1.301-.604 1.154-1.439-.122-.69-.589-.93-1.154-.93zm3.267-.612l-2.206.389.602 3.414 2.258-.398-.133-.757-1.355.24-.108-.61 1.114-.196-.134-.757-1.113.197-.095-.536 1.303-.23-.133-.756zm3.037-.536l-.861.152.174.988c.074.42.238.922.345 1.282l-.021.004-.461-.71-1.025-1.39-.924.163.602 3.415.861-.152-.174-.988c-.074-.42-.235-.9-.345-1.282l.02-.004.46.704 1.027 1.395.924-.163-.602-3.414zm-6.59-3.88l-1.758 3.47 4.597-.812-2.838-2.657z"
  }), React.createElement("path", {
    d: "M7.867 13.726c.1.565.375.901.733.902.035 0 .07-.004.106-.01.41-.072.593-.505.484-1.125-.11-.62-.424-.932-.834-.86-.41.072-.599.474-.49 1.093zM11.005 12.166l.159.903.326-.057c.357-.063.493-.272.44-.576-.054-.305-.274-.385-.62-.324l-.305.054z"
  }), React.createElement("path", {
    d: "M12 0C5.372 0 0 5.373 0 12c0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12 0-6.626-5.374-12-12-12zm0 1.532c5.78 0 10.468 4.688 10.468 10.468 0 5.782-4.687 10.468-10.468 10.468-5.782 0-10.468-4.686-10.468-10.468C1.532 6.22 6.218 1.532 12 1.532z",
    fillRule: "nonzero"
  })));
}

var _default = SvgOpenCircle;
exports.default = _default;